"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _CustomPropTypes = _interopRequireDefault(require("../utils/CustomPropTypes/CustomPropTypes"));

var _FormLabel = _interopRequireDefault(require("../Forms/FormLabel"));

var _keycode = _interopRequireDefault(require("keycode"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _SwitchItem = _interopRequireDefault(require("./_SwitchItem"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _react = _interopRequireWildcard(require("react"));

var _switch = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/switch.css") : void 0);

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _switch.default);
/** A **Switch** component is used to activate or deactivate an element. It uses a visual metaphor that is known
to the user with visible differences between on and off state. It is recommended to always display the
Switch with a label above it as well as the label of the selected state. For example, the label above
would be "Active", the Switch state would be “on” and the selected state label displayed to the right of
the Switch would be “Yes”. */

var Switch = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var _classnames;

  var checked = _ref.checked,
      children = _ref.children,
      compact = _ref.compact,
      cssNamespace = _ref.cssNamespace,
      disabled = _ref.disabled,
      className = _ref.className,
      id = _ref.id,
      inputProps = _ref.inputProps,
      internalLabels = _ref.internalLabels,
      localizedText = _ref.localizedText,
      onChange = _ref.onChange,
      semantic = _ref.semantic,
      showInternalLabels = _ref.showInternalLabels,
      props = (0, _objectWithoutProperties2.default)(_ref, ["checked", "children", "compact", "cssNamespace", "disabled", "className", "id", "inputProps", "internalLabels", "localizedText", "onChange", "semantic", "showInternalLabels"]);

  var _useState = (0, _react.useState)(!!checked),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isChecked = _useState2[0],
      setIsChecked = _useState2[1];

  (0, _react.useEffect)(function () {
    setIsChecked(!!checked);
  }, [checked]);

  var handleChange = function handleChange(e) {
    setIsChecked(!isChecked);
    onChange(e);
  };

  var onKeyDownSwitch = (0, _react.useCallback)(function (event) {
    switch ((0, _keycode.default)(event)) {
      case 'enter':
        event.preventDefault();
        event.stopPropagation();
        setIsChecked(!isChecked);
        break;

      default:
    }
  });
  var spanClasses = classnames("".concat(cssNamespace, "-switch"), (_classnames = {}, (0, _defineProperty2.default)(_classnames, "".concat(cssNamespace, "-switch--compact"), compact), (0, _defineProperty2.default)(_classnames, "".concat(cssNamespace, "-switch--semantic"), semantic), _classnames));
  var internalLabelDisplay;

  if (internalLabels && showInternalLabels) {
    var internalLabelText = isChecked ? internalLabels.checked.text : internalLabels.unchecked.text;
    internalLabelDisplay = /*#__PURE__*/_react.default.createElement("span", {
      "aria-live": "polite",
      className: classnames("".concat(cssNamespace, "-switch__text"))
    }, internalLabelText);
  }

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_FormLabel.default, (0, _extends2.default)({
    disabled: disabled
  }, props, {
    htmlFor: id,
    onKeyDown: onKeyDownSwitch
  }), children), /*#__PURE__*/_react.default.createElement("label", {
    className: classnames("".concat(cssNamespace, "-switch__label"))
  }, internalLabelDisplay, /*#__PURE__*/_react.default.createElement("span", {
    className: spanClasses
  }, /*#__PURE__*/_react.default.createElement("input", (0, _extends2.default)({}, inputProps, {
    "aria-checked": isChecked,
    "aria-label": localizedText.switchLabel,
    checked: isChecked,
    className: classnames("".concat(cssNamespace, "-switch__input")),
    disabled: disabled,
    id: id,
    onChange: handleChange,
    ref: ref,
    type: "checkbox"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: classnames("".concat(cssNamespace, "-switch__wrapper"))
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classnames("".concat(cssNamespace, "-switch__track"))
  }, internalLabels ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_SwitchItem.default, {
    glyph: internalLabels.checked.glyph,
    text: internalLabels.checked.text,
    type: "on"
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: classnames("".concat(cssNamespace, "-switch__handle")),
    role: "presentation"
  }), /*#__PURE__*/_react.default.createElement(_SwitchItem.default, {
    glyph: internalLabels.unchecked.glyph,
    text: internalLabels.unchecked.text,
    type: "off"
  })) : /*#__PURE__*/_react.default.createElement("span", {
    className: classnames("".concat(cssNamespace, "-switch__handle")),
    role: "presentation"
  }))))));
});

Switch.displayName = 'Switch';
process.env.NODE_ENV !== "production" ? Switch.propTypes = {
  /** Set to true for component to be checked on render */
  checked: _propTypes.default.bool,

  /** Node(s) to render within the component */
  children: _propTypes.default.node,

  /** CSS class(es) to add to the element */
  className: _propTypes.default.string,

  /** Set to **true** to enable compact mode */
  compact: _propTypes.default.bool,

  /** Set to **true** to mark component as disabled and make it non-interactive */
  disabled: _propTypes.default.bool,

  /** Value for the `id` attribute on the element */
  id: _propTypes.default.string,

  /** Additional props to be spread to the `<input>` element */
  inputProps: _propTypes.default.object,

  /** Provide text and/or an icon for labels inside the Switch component */
  internalLabels: _propTypes.default.shape({
    checked: _propTypes.default.shape(_SwitchItem.default.PropTypes),
    unchecked: _propTypes.default.shape(_SwitchItem.default.PropTypes)
  }),

  /** Additional props to be spread to the `<label>` element */
  labelProps: _propTypes.default.object,

  /** Localized text to be updated based on location/language */
  localizedText: _CustomPropTypes.default.i18n({
    switchLabel: _propTypes.default.string
  }),

  /** Set to **true** to add semantic styling */
  semantic: _propTypes.default.bool,

  /** Set to true to display text from `internalLabels` next to the switch */
  showInternalLabels: _propTypes.default.bool,

  /**
   * Callback function; triggered when the switch state changes
   * i.e. a change event is fired on the underlying HTML `<input>`.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent. See https://reactjs.org/docs/events.html.
   * @returns {void}
   * */
  onChange: _propTypes.default.func
} : void 0;
Switch.defaultProps = {
  localizedText: {
    switchLabel: 'Switch'
  },
  onChange: function onChange() {}
};

var _default = (0, _withStyles.default)(Switch);

exports.default = _default;